import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { speakingPart2Data, getDataForDifficulty } from './data/skills/speaking/speakingPart2';

export default function SpeakingPart2() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : speakingPart2Data)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
